function getCmsInfoForPage(pageProps) {
  var _a, _b;
  if (!pageProps) {
    return {};
  }
  const cmsInfo = {};
  let categories;
  let tags;
  let pageIdentifiers;
  if ("post" in pageProps) {
    categories = pageProps.post.categories;
    tags = pageProps.post.postTags;
    pageIdentifiers = ((_a = pageProps.post) == null ? void 0 : _a.pageIdentifiers) || [];
  } else if ("category" in pageProps) {
    categories = [{
      slug: pageProps.category.slug
    }];
  } else if ("tag" in pageProps) {
    tags = [{
      slug: pageProps.tag.slug
    }];
  }
  if ("page" in pageProps) {
    pageIdentifiers = ((_b = pageProps.page) == null ? void 0 : _b.pageIdentifiers) || [];
  }
  if (categories == null ? void 0 : categories.length) {
    cmsInfo.taxonomy_categories_txt = categories.map((category) => category.slug);
  }
  if (tags == null ? void 0 : tags.length) {
    cmsInfo.taxonomy_tags_txt = tags.map((tag) => tag.slug);
  }
  if (pageIdentifiers == null ? void 0 : pageIdentifiers.length) {
    cmsInfo.taxonomy_page_identifier_txt = pageIdentifiers.map((pageIdentifier) => pageIdentifier.slug);
  }
  return cmsInfo;
}
export {
  getCmsInfoForPage
};
